import type { ComponentType } from 'react';
import type { LeadSubmitResult, PublicLeadFormData } from '../../../services/leadTypes';
import { ProductArko } from './ProductArko';
import { ProductOrbis } from './ProductOrbis';
import { ProductDokumente } from './ProductDokumente';
import { ProductLitigation } from './ProductLitigation';
import { ProductLexcore } from './ProductLexcore';
import { ProductRecht } from './ProductRecht';
import { ProductDiktat } from './ProductDiktat';
import { ProductPortal } from './ProductPortal';

/** Props, die App.tsx beim Merge an Produktseiten durchreicht. */
export interface T05ProductPageProps {
  onLoginClick?: () => void;
  onLeadSubmit?: (data: PublicLeadFormData) => Promise<LeadSubmitResult> | LeadSubmitResult;
}

export interface T05ProductRouteConfig {
  path: string;
  element: ComponentType<T05ProductPageProps>;
}

export const ROUTE_PRODUCT_LEXCORE = '/produkt/lexcore';
export const ROUTE_RECHT = '/recht';

/**
 * T05 Sub-Produktseiten — in App.tsx einbinden.
 */
export const T05_PRODUCT_ROUTES: T05ProductRouteConfig[] = [
  { path: '/produkt/orbis', element: ProductOrbis },
  { path: '/produkt/arko', element: ProductArko },
  { path: '/produkt/dokumente', element: ProductDokumente },
  { path: '/produkt/litigation-engine', element: ProductLitigation },
  { path: ROUTE_PRODUCT_LEXCORE, element: ProductLexcore },
  { path: '/produkt/diktat', element: ProductDiktat },
  { path: '/produkt/portal', element: ProductPortal },
  { path: ROUTE_RECHT, element: ProductRecht },
];
